import { memo, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';

import './Loader.css';

const Loader = ({ on, style }) => {
  const nodeRef = useRef(null); // 👈 Create a ref

  return (
    <CSSTransition
      in={on}
      classNames="vp-loader"
      timeout={300}
      mountOnEnter
      unmountOnExit
      nodeRef={nodeRef} // 👈 Pass nodeRef to CSSTransition
    >
      <div ref={nodeRef} className="vp-loader" style={style}>
        <div />
      </div>
    </CSSTransition>
  );
};

export default memo(Loader);
